import { GalaxyApi } from "@/api";
import { rethrowSimple } from "@/utils/simple-error";
const DEFAULT_PAGE_SIZE = 10;
/**
 * Get a list of archived histories.
 */
export async function fetchArchivedHistories(options) {
    const params = optionsToApiParams(options);
    const { response, data, error } = await GalaxyApi().GET("/api/histories/archived", {
        params: {
            query: params,
        },
    });
    if (error) {
        rethrowSimple(error);
    }
    const totalMatches = parseInt(response.headers.get("total_matches") ?? "0");
    if (params.view === "detailed") {
        return {
            histories: data,
            totalMatches,
        };
    }
    return {
        histories: data,
        totalMatches,
    };
}
function optionsToApiParams(options) {
    const params = {};
    if (options.query) {
        params.q = ["name-contains"];
        params.qv = [options.query];
    }
    const pageSize = options.pageSize ?? DEFAULT_PAGE_SIZE;
    params.offset = (options.currentPage ? options.currentPage - 1 : 0) * pageSize;
    params.limit = pageSize;
    params.order = options.sortBy ? `${options.sortBy}${options.sortDesc ? "-dsc" : "-asc"}` : undefined;
    params.view = options.view;
    params.keys = options.keys;
    return params;
}
